<auth-header></auth-header>
<page-title pageTitle="{{ title }}"></page-title>
<div class="container">
  <div class="row">
    <div class="col-12">
      <div *ngFor="let section of faqs">
        <accordion
          [accordianInfo]="getFaqSection(section)"
          [isSeperatorRequired]="false"
          class="row"
        >
          <rmp-html-viewer
            id="section-{{ section.informationId }}"
            [content]="getFaqContent(section)"
            [fullWidth]="true"
            [hasBorder]="false"
          >
          </rmp-html-viewer>
        </accordion>
      </div>
    </div>
  </div>
</div>
<div class="fixed-faq-footer">
  <app-footer [showSupportNumber]="false"></app-footer>
</div>
